// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.truncate {
  display: inline-block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}

.token {
  background: #f4f4f4;
  position: relative;
  border: 3px solid #cccccc;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
}
.token th, .token td {
  padding: 2px 10px;
}
.token th {
  text-align: right;
  border-right: 2px solid #cccccc;
}
.token td span {
  line-height: 30px;
}
.token .form-control {
  display: inline;
  height: auto;
  line-height: 1;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/methods/fido/fido.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,iBAAA;EACA,+BAAA;AAAJ;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAFJ","sourcesContent":[".truncate {\n  display: inline-block;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.token {\n  background: #f4f4f4;\n  position: relative;\n  border: 3px solid #cccccc;\n  padding: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n\n  th, td {\n    padding: 2px 10px;\n  }\n\n  th {\n    text-align: right;\n    border-right: 2px solid #cccccc;\n  }\n\n  td span {\n    line-height: 30px;\n  }\n\n  .form-control {\n    display: inline;\n    height: auto;\n    line-height: 1;\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
